import React, { useState, useEffect } from "react";
import ReactDOM from "react-router-dom";
import moment from "moment";
import { Row, Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import {
  DateRangePicker,
  DateRange,
} from "../../../components/common/DateRangePicker";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Colxx } from "../../../components/common/CustomBootstrap";
import { isAnalyticsRC, isAnalyticsRBD } from "../../../helpers/Roles";
import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";
import IntlMessages from "../../../helpers/IntlMessages";
import { injectIntl } from "react-intl";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { NotificationManager } from "../../../components/common/react-notifications";
import classnames from "classnames";

const ContentComponent = (props) => {
  const { messages } = props.intl;
  const [state, setState] = useState({
    open: false,
  });

  useEffect(() => {
    scrollDetect();
  }, []);

  function scrollDetect() {
    window.onscroll = function () {
      if (window.scrollY && window.scrollY > 200) {
        setState({
          ...state,
          open: false,
        });
      }
    };
  }

  const getDateLabel = (dates) => {
    let date_start = moment(dates.startDate).clone().startOf("days");
    let date_end = moment(dates.endDate).clone().startOf("days");

    if (
      date_start.isSame(moment().startOf("days")) &&
      date_end.isSame(moment().startOf("days"))
    ) {
      return props.intl.formatMessage({ id: "analytics.today" });
    } else if (
      date_start.isSame(moment().subtract(1, "days").startOf("days")) &&
      date_end.isSame(moment().subtract(1, "days").startOf("days"))
    ) {
      return props.intl.formatMessage({ id: "analytics.yesterday" });
    } else if (
      date_start.isSame(moment().subtract(6, "days").startOf("days")) &&
      date_end.isSame(moment().startOf("days"))
    ) {
      return props.intl.formatMessage({ id: "analytics.7-days-ago" });
    } else if (
      date_start.isSame(moment().startOf("isoWeeks").startOf("days")) &&
      date_end.isSame(moment().endOf("isoWeeks").startOf("days"))
    ) {
      return props.intl.formatMessage({ id: "analytics.this-week" });
    } else if (
      date_start.isSame(
        moment().subtract(1, "weeks").startOf("isoWeeks").startOf("days"),
      ) &&
      date_end.isSame(
        moment().subtract(1, "weeks").endOf("isoWeeks").startOf("days"),
      )
    ) {
      return props.intl.formatMessage({ id: "analytics.last-week" });
    } else if (
      date_start.isSame(moment().subtract(30, "days").startOf("days")) &&
      date_end.isSame(moment().startOf("days"))
    ) {
      return props.intl.formatMessage({ id: "analytics.30-days-ago" });
    } else if (
      date_start.isSame(moment().startOf("months").startOf("days")) &&
      date_end.isSame(moment().startOf("days"))
    ) {
      return props.intl.formatMessage({ id: "analytics.this-month" });
    } else if (
      date_start.isSame(
        moment().subtract(1, "months").startOf("months").startOf("days"),
      ) &&
      date_end.isSame(
        moment().subtract(1, "months").endOf("months").startOf("days"),
      )
    ) {
      return props.intl.formatMessage({ id: "analytics.last-month" });
    } else {
      return `${date_start.format("YYYY-MM-DD")} ${props.intl.formatMessage({ id: "input.to" })} ${date_end.format(
        "YYYY-MM-DD",
      )}`;
    }
  };

  const onSelectDropdown = (dates) => {
    if (!isAnalyticsRBD()) return false;

    let date_start = moment();
    let date_end = moment();
    let all = false;
    let dateLabel = "";

    // Kiểm tra xem có phải là "Tất cả" không bằng cách check nếu startDate và endDate là ngày mai
    // (vì "Tất cả" dùng moment().add(1, 'days') làm placeholder)
    const isTomorrowStart = moment(dates.startDate)
      .startOf("days")
      .isSame(moment().add(1, "days").startOf("days"));
    const isTomorrowEnd = moment(dates.endDate)
      .startOf("days")
      .isSame(moment().add(1, "days").startOf("days"));
    const isAllOption = isTomorrowStart && isTomorrowEnd;

    if (isAllOption) {
      // Đây là option "Tất cả"
      all = true;
      date_start = moment().startOf("days");
      date_end = moment().startOf("days");
      dateLabel = props.intl.formatMessage({ id: "analytics.all" });
    } else {
      // Use localized strings for comparison
      const today = props.intl.formatMessage({ id: "analytics.today" });
      const yesterday = props.intl.formatMessage({ id: "analytics.yesterday" });
      const last7Days = props.intl.formatMessage({
        id: "analytics.7-days-ago",
      });
      const thisWeek = props.intl.formatMessage({ id: "analytics.this-week" });
      const lastWeek = props.intl.formatMessage({ id: "analytics.last-week" });
      const last30Days = props.intl.formatMessage({
        id: "analytics.30-days-ago",
      });
      const thisMonth = props.intl.formatMessage({
        id: "analytics.this-month",
      });
      const lastMonth = props.intl.formatMessage({
        id: "analytics.last-month",
      });

      if (dates.label === today) {
        dateLabel = dates.label;
      } else if (dates.label === yesterday) {
        date_start = moment().subtract(1, "days").startOf("days");
        date_end = moment().subtract(1, "days").startOf("days");
        dateLabel = dates.label;
      } else if (dates.label === last7Days) {
        date_start = moment().subtract(6, "days").startOf("days");
        date_end = moment().startOf("days");
        dateLabel = dates.label;
      } else if (dates.label === thisWeek) {
        date_start = moment().startOf("isoWeeks").startOf("days");
        date_end = moment().endOf("isoWeeks").startOf("days");
        dateLabel = dates.label;
      } else if (dates.label === lastWeek) {
        date_start = moment()
          .subtract(1, "weeks")
          .startOf("isoWeeks")
          .startOf("days");
        date_end = moment()
          .subtract(1, "weeks")
          .endOf("isoWeeks")
          .startOf("days");
        dateLabel = dates.label;
      } else if (dates.label === last30Days) {
        date_start = moment().subtract(30, "days").startOf("days");
        date_end = moment().startOf("days");
        dateLabel = dates.label;
      } else if (dates.label === thisMonth) {
        date_start = moment().startOf("months").startOf("days");
        date_end = moment().startOf("days");
        dateLabel = dates.label;
      } else if (dates.label === lastMonth) {
        date_start = moment()
          .subtract(1, "months")
          .startOf("months")
          .startOf("days");
        date_end = moment()
          .subtract(1, "months")
          .endOf("months")
          .startOf("days");
        dateLabel = dates.label;
      } else {
        date_start = moment(dates.startDate).startOf("days");
        date_end = moment(dates.endDate).startOf("days");
        dateLabel = getDateLabel(dates);
      }
    }

    props.onChangeSetting({
      dateRange: dates,
      dateLabel,
      all,
      date_start,
      date_end,
      compare: null,
    });
  };

  const onRequestRangeDate = ({ date_start, date_end, all }) => {
    if (!isAnalyticsRBD()) return false;

    props.onChangeDate({ date_start, date_end, all });
  };

  const onToggleCompare = () => {
    if (!isAnalyticsRC()) return false;

    props.onToggleSetting("compare", !props.setting.compare);
  };

  const toggleTooltip = () => {
    setState({ ...state, open: !state.open });
  };

  const onSubmitRequest = () => {
    if (!isAnalyticsRBD()) return false;

    onRequestRangeDate({
      all: props.setting.all,
      date_start: props.setting.date_start,
      date_end: props.setting.date_end,
    });

    setState({
      ...state,
      open: false,
    });
  };

  const isToday =
    moment(props.setting.dateRange.startDate).isSame(moment(), "day") &&
    moment(props.setting.dateRange.endDate).isSame(moment(), "day");

  return (
    <Row className="date-picker plr-sm-above mb-4" id="picker">
      <Colxx xxs="7" md="6">
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select theme-select left-0"
          classNamePrefix="react-select"
          name="type"
          placeholder={<IntlMessages id="companies.unset" />}
          options={props.data_companies.data}
          isDisabled={props.hide_button_add}
          onChange={
            props.hide_button_add
              ? null
              : (e) => {
                  props.onChangeCompanies(e);
                }
          }
          value={props.data_companies.data.find(
            (_item) => _item.value === props.data_companies.selected,
          )}
        />
      </Colxx>
      <Colxx xxs="5" md="6" className="d-flex justify-content-end">
        {props.onExportExcel && (
          <a
            href="#export"
            className="d-flex justify-content-center align-items-center theme-button excel-export-btn mr-2"
            onClick={(e) => {
              e.preventDefault();
              if (!props.hide_button_add) {
                props.onExportExcel();
              }
            }}
            style={{
              opacity: props.hide_button_add ? 0.5 : 1,
              pointerEvents: props.hide_button_add ? "none" : "auto",
            }}
          >
            <i className="simple-icon-cloud-download mr-2" />
            <span className="d-none d-md-inline">Excel</span>
          </a>
        )}
        <a
          href="#section"
          id="datePicker"
          className="d-flex justify-content-center align-items-center theme-button"
          onClick={(e) => {
            e.preventDefault();
            toggleTooltip();
          }}
        >
          {" "}
          <i className="simple-icon-calendar mr-3" />{" "}
          <span className="text-one mr-3 d-none d-md-flex">
            {props.setting.dateLabel}
          </span>{" "}
          <i className="simple-icon-arrow-down text-small" />{" "}
        </a>
        <Popover
          isOpen={state.open}
          toggle={toggleTooltip}
          placement="right-start"
          target="datePicker"
          trigger="click"
          container={document.getElementById("picker")}
          className="custom-tooltip-date-picker"
        >
          <PopoverBody className="custom-tooltip-date-picker__popover-body">
            <PerfectScrollbar
              options={{
                suppressScrollX: true,
                wheelPropagation: true,
              }}
            >
              <div className="p-2">
                <div className="custom-daterange__container">
                  <div className="date-label mb-2">
                    <DateRangePicker
                      initialDateRange={props.setting.dateRange}
                      open={true}
                      onChange={(range) => onSelectDropdown(range)}
                      definedRanges={[
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.today",
                          }),
                          startDate: moment(),
                          endDate: moment(),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.yesterday",
                          }),
                          startDate: moment().subtract(1, "days"),
                          endDate: moment().subtract(1, "days"),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.7-days-ago",
                          }),
                          startDate: moment().subtract(6, "days"),
                          endDate: moment(),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.this-week",
                          }),
                          startDate: moment().startOf("isoWeeks"),
                          endDate: moment().endOf("isoWeeks"),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.last-week",
                          }),
                          startDate: moment()
                            .subtract(1, "weeks")
                            .startOf("isoWeeks"),
                          endDate: moment()
                            .subtract(1, "weeks")
                            .endOf("isoWeeks"),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.30-days-ago",
                          }),
                          startDate: moment().subtract(30, "days"),
                          endDate: moment().subtract(1, "days"),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.this-month",
                          }),
                          startDate: moment().startOf("months"),
                          endDate: moment(),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.last-month",
                          }),
                          startDate: moment()
                            .subtract(1, "months")
                            .startOf("months"),
                          endDate: moment()
                            .subtract(1, "months")
                            .endOf("months"),
                        },
                        {
                          label: props.intl.formatMessage({
                            id: "analytics.all",
                          }),
                          startDate: moment().add(1, "days"),
                          endDate: moment().add(1, "days"),
                        },
                      ]}
                    />
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <span className="switch-compare">
                        <span onClick={onToggleCompare}>
                          <IntlMessages id="analytics.compare" />
                        </span>
                        <Switch
                          disabled={
                            !isAnalyticsRC() ||
                            (props.hide_button_add && !isToday)
                          }
                          onChange={onToggleCompare}
                          checked={props.setting.compare}
                          className="custom-switch custom-switch-primary custom-switch-small"
                        />
                      </span>
                      <span className="mr-2">
                        <Button
                          disabled={!isAnalyticsRC()}
                          color="primary"
                          onClick={() => {
                            if (props.hide_button_add && !isToday) {
                              NotificationManager.error(
                                messages["analytics.upgrade.notification"],
                                messages["analytics.upgrade.title"],
                                3000,
                                null,
                                null,
                                "",
                              );
                            } else {
                              onSubmitRequest();
                            }
                          }}
                          className={classnames("position-relative", {
                            disable: props.hide_button_add && !isToday,
                          })}
                        >
                          <IntlMessages id="analytics.update" />
                          {props.hide_button_add ? (
                            <i className="simple-icon-diamond diamond-upgrade-add" />
                          ) : null}
                        </Button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </PerfectScrollbar>
          </PopoverBody>
        </Popover>
      </Colxx>
    </Row>
  );
};

export default injectIntl(ContentComponent);
